import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    BaseSiteService,
    GlobalMessageService,
    RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { CommonUtils } from 'src/app/shared/utils/common.utils';
import {
    NumberSix,
    NumberTen,
    NumberThree,
} from 'src/app/shared/utils/constants/global.constants';
import * as config from '../../../app/shared/config/app.config';
import { CustomInfluenzaService } from '../custom-influenza.service';

@Component({
    selector: 'app-influenza-vaccine-locator',
    templateUrl: './influenza-vaccine-locator.component.html',
    styleUrls: ['./influenza-vaccine-locator.component.scss'],
    standalone: false
})
export class InfluenzaVaccineLocatorComponent implements OnInit, OnDestroy {
  userData: any;
  b2bUnitID: any;
  @ViewChildren('editContentSection') editList: any;
  searchText;
  confirmStatus: boolean = false;
  initialFlagValueForAll: boolean = false;
  arrForStore = [];
  baseSiteId: any;
  referer: any;
  totalLocationsCount: any;
  totalactiveLocationsCount: any;
  successMsg: boolean = false;
  countofEnrolledStatus: any;
  cMethodVal: boolean = false;
  emailErrorMsg2: boolean = false;
  emailErrorMsg: boolean = false;
  phoneErrorMsg: boolean = false;
  nameErrorMsg: boolean = false;
  addressErrorMsg: boolean = false;
  cityErrorMsg: boolean = false;
  cityErrorMsg2: boolean = false;
  zipcodeErrorMsg: boolean = false;
  zipcodeErrorMsg2: boolean = false;
  dataSetForEdit: any;
  locationName: any;
  addressDetails;
  editOn: boolean = false;
  arrLength: any;
  locationSelectorOn: boolean = false;
  ordersListCopy: any;
  statesArr: Array<any>;
  facilityType: Array<any>;
  subscriptions = [];
  public ordersList;
  userAccountgetData: any;
  isAllActive = false;
  isAllFlubokActive = false;
  isAllFlubokHighDoseActive = false;
  userSub: Subscription;
  baseSub: Subscription;
  stateSub: Subscription;
  fluLocatorSub: Subscription;
  fluSub: Subscription;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly rt: Router,
    private readonly route: ActivatedRoute,
    private readonly baseService: BaseService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly user: UserAccountFacade,
    private readonly baseSiteService: BaseSiteService,
    private readonly globalMessage: GlobalMessageService,
    private readonly pfService: CustomProfileAndPreferencesService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.referer = params.referer;
    });
    this.pfService.getStates();
    this.initializeOninit();
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
    this.baseSub?.unsubscribe();
    this.fluLocatorSub?.unsubscribe();
    this.stateSub?.unsubscribe();
    this.fluSub?.unsubscribe();
  }
  test(event) {
    const self = this;
    if (event !== '') {
      if (this.ordersList.length < 1) {
        this.ordersList = this.ordersListCopy;
      }
      const result = self.ordersList.filter((res) => {
        return (
          res.customerName.toLowerCase().includes(event.toLowerCase()) ||
          res.address.toLowerCase().includes(event.toLowerCase()) ||
          res.city.toLowerCase().includes(event.toLowerCase()) ||
          res.state.toLowerCase().includes(event.toLowerCase()) ||
          res.phone.toLowerCase().includes(event.toLowerCase()) ||
          res.zipcode.toLowerCase().includes(event.toLowerCase())
        );
      });

      this.ordersList = result;
    } else {
      this.ordersList = this.ordersListCopy;
      this.ordersList.forEach((el) => {
        el.statusIdCopy = el.statusId;
      });
    }
  }

  initializeOninit() {
    this.userSub = this.user.get().subscribe((res) => {
      if (res) {
        this.userAccountgetData = res;
        this.baseSub = this.baseService
          .get(config.GET_ACCOUNT_ID)
          .subscribe((res) => {
            this.b2bUnitID = res?.defaultB2BUnit?.uid;
            const params =
              this.referer === 'my-account/profile' ||
              this.referer === 'influenza/dashboard'
                ? { viewAllLocations: true }
                : '';
            this.influenzaService.getFluLocatorDetails(
              this.userAccountgetData.uid,
              this.b2bUnitID,
              params
            );
          });
      }
    });
    this.stateSub = this.pfService.states.subscribe((res) => {
      this.statesArr = res.regions;
    });

    this.fluLocatorSub = this.influenzaService.fluLocatorDetails.subscribe(
      (resp) => {

        this.ordersList = JSON.parse(JSON.stringify(resp.fluLocators));
        this.ordersListCopy = JSON.parse(JSON.stringify(this.ordersList));
        this.totalLocationsCount = this.ordersList.length;
        let filteredActivelocs = this.ordersList.filter(
          (locs) => locs.statusId != 2
        );
        this.totalactiveLocationsCount = filteredActivelocs.length;
        this.cdr.detectChanges();
        this.ordersList.forEach((ele) => {
          ele.statusIdCopy = ele.statusId;
          ele.originalState = ele.state;
          ele.state = 'US-' + ele.state;
          ele.isSelected = true;
          this.validateFaxNumber(ele.phone, 'phone', ele.locatorId);
          this.validateFaxNumber(ele.fax, 'fax', ele.locatorId);
        });
        this.arrLength = this.ordersList.length;
        this.cdr.detectChanges();
      }
    );
  }

  SaveAction() {
    let explodedState =
      typeof this.dataSetForEdit.state === 'object'
        ? this.dataSetForEdit.state.isocode.split('-')
        : this.dataSetForEdit.state.split('-');
    let obj = {
      customerName: this.dataSetForEdit.customerName,
      locatorId: this.dataSetForEdit.locatorId,
      address: this.dataSetForEdit.address,
      city: this.dataSetForEdit.city,
      state: explodedState[1],
      zipcode: this.dataSetForEdit.zipcode,
      originalZipcode: this.dataSetForEdit.zipcode,
      phone: this.dataSetForEdit.phone,
      fax: '',
      email: '',
      statusId: this.dataSetForEdit.statusId,
      materialOptoutStatusList: [
        {
          material: this.dataSetForEdit.fluBlockProductId,
          optOut: this.dataSetForEdit.fluBlockOptedIn === 'Not Offered' ? 1 : 0,
          originalOptOut:
            this.dataSetForEdit.fluBlockOptedInCopy === 'Not Offered' ? 1 : 0,
        },
        {
          material: this.dataSetForEdit.fluZoneProductId,
          optOut: this.dataSetForEdit.fluZoneOptedIn === 'Not Offered' ? 1 : 0,
          originalOptOut:
            this.dataSetForEdit.fluZoneOptedInCopy === 'Not Offered' ? 1 : 0,
        },
      ],
      operId: this.dataSetForEdit.mdg_num,
      bypassMaterialEnrollment: 0,
      materialsEnrolled: '',
      materialsOptedIn: '',
      showNotOfferedAlert: true,
    };

    this.influenzaService.saveFluLocatorDetails(
      this.userAccountgetData.uid,
      obj
    );
    this.influenzaService.flulocatorDetailsSave.subscribe((res) => {
      if (res) {
        this.initializeOninit();
        this.editOn = false;
        this.successMsg = true;
        this.router.goByUrl('/vaccineLocatorPage');
        location.reload();
      }
    });
  }
  backToDashBoard() {
    this.router.goByUrl(this.referer);
  }
  cMethodElection(method) {
    if (method === 'email') {
      this.cMethodVal = true;
    } else {
      this.cMethodVal = false;
    }
  }

  inputValidation(nameVal, type) {
    if (nameVal === '') {
      if (type === 'name') {
        this.nameErrorMsg = true;
      } else if (type === 'address') {
        this.addressErrorMsg = true;
      }
    } else {
      if (type === 'name') {
        this.nameErrorMsg = false;
      } else if (type === 'address') {
        this.addressErrorMsg = false;
      }
    }
  }

  cityvalidation(val) {
    if (val === '') {
      this.cityErrorMsg = true;
      this.cityErrorMsg2 = false;
      return;
    } else {
      this.cityErrorMsg = false;
      if (/[^@#!$%*()=]+$/.test(val)) {
        this.cityErrorMsg2 = false;
      } else {
        this.cityErrorMsg2 = true;
        return;
      }
    }
  }

  SaveActionforAll() {
    let arrForTotalSet = [];
    this.ordersList.forEach((el) => {
      let obj = {
        isSelected: true,
        customerName: el.customerName,
        locatorId: el.locatorId,
        address: el.address,
        city: el.city,
        state: el.originalState,
        zipcode: el.zipcode,
        originalZipcode: el.zipcode,
        phone: el.phone,
        fax: '',
        email: '',
        statusId: this.isAllActive ? 1 : 2,
        originalStatusId: el.statusId,
        materialOptoutStatusList: [
          {
            material: el.fluBlockProductId,
            optOut: this.isAllFlubokActive ? 0 : 1,
            originalOptOut: this.isAllFlubokHighDoseActive ? 1 : 0,
          },
          {
            material: el.fluZoneProductId,
            optOut: this.isAllFlubokHighDoseActive ? 0 : 1,
            originalOptOut: this.isAllFlubokActive ? 1 : 0,
          },
        ],
        operId: el.mdg_num,
        bypassMaterialEnrollment: 0,
        materialsEnrolled: '',
        materialsOptedIn: '',
        showNotOfferedAlert: true,
      };

      arrForTotalSet.push(obj);
    });
    let objFinalStructure = {
      fluLocators: arrForTotalSet,
    };
    this.influenzaService.saveFluLocatorDetailsForAll(
      this.userAccountgetData.uid,
      objFinalStructure
    );
    this.fluSub = this.influenzaService.flulocatorDetailsSaveForAll.subscribe(
      (res) => {
        if (res) {
          location.reload();
        }
      }
    );
  }
  applySettingAll() {
    this.arrForStore = [];
    this.ordersList.forEach((e) => {
      e.editModeOn = false;
      if (this.locationSelectorOn) {
        e.thisEleChecked = true;
      } else {
        e.thisEleChecked = false;
      }
    });
  }
  callsaveAction() {
    this.confirmStatus = false;
    this.SaveActionforAll();
  }
  clickApplytoAll() {
    this.confirmStatus = true;
  }
  cancelPopUp() {
    this.confirmStatus = false;
  }
  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }
  cancelAllLocation() {
    location.reload();
  }
  changeEnrollFlag(id, type, flag) {
    if (id === 'All') {
      this.initialFlagValueForAll = true;
      this.ordersList.forEach((ele) => {
        if (type === 'enrollflag') {
          ele.statusId = flag.target.checked;
        }
        if (type === 'flubokActive') {
          if (!flag.target.checked) {
            ele.fluBlockOptedIn = 'Not Offered';
          } else {
            ele.fluBlockOptedIn = 'Offered';
          }
        }

        if (type === 'flubokHighDoseActive') {
          if (!flag.target.checked) {
            ele.fluZoneOptedIn = 'Not Offered';
          } else {
            ele.fluZoneOptedIn = 'Offered';
          }
        }
        if (ele.thisEleChecked) {
          ele[type] = flag.target.checked;
        }
      });
    } else {
      let obj = {};
      let objSet = {};
      this.ordersList.forEach((ele) => {
        ele.fluZoneOptedInCopy = ele.fluZoneOptedIn;
        ele.fluBlockOptedInCopy = ele.fluBlockOptedIn;
        if (ele.locatorId === id) {
          if (type === 'enrollflag') {
            ele.statusId = !flag ? 2 : 1;
            ele.statusIdCopy = !flag ? 2 : 1;
          }

          if (type === 'flubokActive') {
            if (!flag) {
              ele.fluZoneOptedIn = 'Not Offered';
            } else {
              ele.fluZoneOptedIn = 'Offered';
            }
          }

          if (type === 'flubokHighDoseActive') {
            if (!flag) {
              ele.fluBlockOptedIn = 'Not Offered';
            } else {
              ele.fluBlockOptedIn = 'Offered';
            }
          }

          objSet = {
            influenzaContactInfos: [ele],
          };
        }
      });

      this.ordersList.forEach((ele) => {
        if (ele.locatorId === id) {
          this.dataSetForEdit = ele;
        }
      });
      this.SaveAction();
    }
  }

  updateFluZoneFluBlok(id, type, flag) {
    if (id === 'All') {
      this.initialFlagValueForAll = true;
      this.ordersList.forEach((ele) => {
        if (ele.thisEleChecked) {
          ele[type] = flag.target.checked;
        }
      });
    } else {
      let obj = {};
      let objSet = {};
      this.ordersList.forEach((ele) => {
        ele.fluZoneOptedInCopy = ele.fluZoneOptedIn;
        ele.fluBlockOptedInCopy = ele.fluBlockOptedIn;
        if (ele.locatorId === id) {
          if (type === 'enrollflag') {
            if (!flag) {
              ele.statusId = 2;
            } else {
              ele.statusId = 1;
            }
          }

          if (type === 'flubokActive') {
            if (!flag) {
              ele.fluZoneOptedIn = 'Not Offered';
            } else {
              ele.fluZoneOptedIn = 'Offered';
            }
          }

          if (type === 'flubokHighDoseActive') {
            if (!flag) {
              ele.fluBlockOptedIn = 'Not Offered';
            } else {
              ele.fluBlockOptedIn = 'Offered';
            }
          }
          objSet = {
            influenzaContactInfos: [ele],
          };
        }
      });
    }
  }
  numberValidation(nameVal) {
    if (nameVal === '') {
      this.zipcodeErrorMsg = true;
      this.zipcodeErrorMsg2 = false;
      return;
    } else {
      this.zipcodeErrorMsg = false;
      if (/^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$/.test(nameVal)) {
        this.zipcodeErrorMsg2 = false;
      } else {
        this.zipcodeErrorMsg2 = true;
        return;
      }
    }
  }

  validateFaxNumber(event, type, id) {
    let newVal;
    if (event === '' || event?.length < 10) {
      if (type === 'phone') {
        this.phoneErrorMsg = true;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }

      if (type === 'phone') {
        this.dataSetForEdit.phone = newVal;
      }
    } else if (event?.length === 0) {
      if (type === 'phone') {
        this.phoneErrorMsg = true;
      }
    } else {
      if (type === 'phone') {
        this.phoneErrorMsg = false;
      }

      if (event === null) {
        return null;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }

      if (type === 'phone') {
        this.ordersList.forEach((element) => {
          if (element.phone === event) {
            element.phone = newVal;
          }
        });
      }
    }
  }
  editModeOn(id) {
    this.editOn = true;
    this.ordersList.forEach((ele) => {
      if (ele.locatorId === id) {
        ele.editModeOn = true;
        this.dataSetForEdit = ele;
      } else {
        ele.editModeOn = false;
      }
    });
  }
  cancelEditSection(id) {
    this.ordersList.forEach((element) => {
      if (element.locatorId === id) {
        element.editModeOn = false;
      }
    });
    this.editOn = false;
    this.nameErrorMsg = false;
    this.addressErrorMsg = false;
    this.cityErrorMsg = false;
    this.zipcodeErrorMsg = false;
    this.phoneErrorMsg = false;
    this.initializeOninit();
  }

  validateEmailmethod(vl) {
    if (vl === '') {
      this.emailErrorMsg2 = true;
    } else {
      this.emailErrorMsg2 = false;
      if (!this.validateEmail(vl)) {
        this.emailErrorMsg = true;
      } else {
        this.emailErrorMsg = false;
      }
    }
  }

  validateEmail(emailID) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(emailID)) {
      return true;
    }
    return false;
  }

  selectRadioFrRw(id, e) {
    if (e.target.checked) {
      if (!this.arrForStore.includes(id)) {
        this.arrForStore.push(id);
      }
    } else {
      this.arrForStore = this.arrForStore.filter(function (item) {
        return item !== id;
      });
      this.ordersList.forEach((e) => {
        if (e.locatorId === id) {
          e.thisEleChecked = false;
        }
      });
    }
    this.arrForStore.forEach((el) => {
      this.ordersList.forEach((ele) => {
        if (el === ele.locatorId) {
          ele['thisEleChecked'] = true;
        }
      });
    });
  }
  searchResult(event) {
    const self = this;
    if (event === '') {
      this.ordersList = JSON.parse(JSON.stringify(this.ordersListCopy));
    } else {
      const result = self.ordersList.filter((res) => {
        return (
          res?.locationName?.toLowerCase().includes(event.toLowerCase()) ||
          res?.firstName?.toLowerCase().includes(event.toLowerCase()) ||
          res?.lastName?.toLowerCase().includes(event.toLowerCase()) ||
          res.shippingAddresses?.country?.isocode
            .toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.town
            ?.toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.line1
            ?.toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.postalCode
            ?.toLowerCase()
            .includes(event.toLowerCase())
        );
      });

      this.ordersList = result;
    }
  }
  toggle(popover) {
    if (popover?.isOpen()) {
      popover?.close();
    } else {
      popover?.open();
    }
  }
}
